__webpack_require__.p = "/bh/ar/customer-service/returns-claims/spareparts/";